/**
 * 内容文案英译表（中文原文 → English）。
 * UI 外壳走 STRINGS/t()；本表收内容层文案（角色/关卡/boss/符卡/台词/曲目），
 * 展示处用 L() 包装：lang=en 查表返回英文（无表项回落原文），lang=zh 恒返回原文。
 * 键必须与被展示的原始中文字符串完全一致（含全角标点）。
 */
export const CONTENT_EN = {
  // ---------------- 角色：简介 ----------------
  '永远元气满满的乐天派，用漫天弹幕把快乐撒向全屏。':
    'An eternal optimist bursting with energy, scattering joy across the screen in a storm of danmaku.',
  '戴着墨镜的冷酷射手，弹无虚发，人狠话不多。':
    'A cool-headed sharpshooter in shades. Every shot lands; words are few.',
  '一点就着的暴脾气，火球所到之処寸草不生。':
    'A short fuse with a shorter temper — where her fireballs land, nothing grows.',
  '爱哭的软妹子，眼泪会自己找到敌人，护盾悄悄守护她。':
    'A timid crybaby. Her tears find enemies on their own, and her shield quietly watches over her.',
  '满脸问号的迷之存在，弹道和敌人一起陷入混乱。':
    'A walking question mark. Her shots — and her enemies — descend into chaos.',
  '热血应援团长，环绕子机就是她的啦啦队。':
    'The hot-blooded cheer squad captain. Her orbiting options are her cheerleaders.',
  '永远睡不醒的重炮手，醒来的一炮惊天动地。':
    'A heavy gunner who can never stay awake — but her waking shots shake the heavens.',
  '卖萌担当，连子弹都是爱你的形状。':
    'The resident cutie. Even her bullets are shaped like love.',

  // ---------------- 角色：普攻 ----------------
  '开心散射': 'Happy Spread',
  '扇形散射，火力提升增加弹道（3→7 向），低速收束':
    'Fan spread. More power adds lanes (3→7); focus narrows the arc.',
  '酷穿双枪': 'Piercing Twin Guns',
  '窄直线贯通弹，火力提升追加斜向副炮':
    'Narrow piercing stream. More power adds diagonal side guns.',
  '怒火三连': 'Triple Rage',
  '贯通火球，火力提升增加弹道（1→5 向），低速合成重击':
    'Piercing fireballs. More power adds lanes (1→5); focus fuses them into one heavy hit.',
  '泪之诱导': 'Homing Tears',
  '自动追踪敌人的泪弹，火力提升增加连发数':
    'Tear shots that track enemies. More power adds volleys.',
  '迷惑散射': 'Confusion Scatter',
  '随机角度散射，火力提升增加弹数':
    'Random-angle scatter. More power adds bullets.',
  '应援直线弹': 'Cheer Stream',
  '直线弹 + 环绕子机，火力提升增加子机数':
    'Straight shots plus orbiting options. More power adds options.',
  '瞌睡重炮': 'Drowsy Cannon',
  '大弹高伤炮，火力提升追加副炮，低速伤害再加成':
    'Huge high-damage shells. More power adds sub-guns; focus boosts damage further.',
  '爱心扩散': 'Heart Spread',
  '心形扩散弹，火力提升增加弹数':
    'Heart-shaped spread shots. More power adds bullets.',

  // ---------------- 角色：炸弹 ----------------
  '满天烟花': 'Sky-Full Fireworks',
  '贯穿主炮': 'Piercing Main Cannon',
  '以自机为中心的纵激光柱，持续 1.5s':
    'A vertical laser column centered on you. Lasts 1.5s.',
  '震爆': 'Shockblast',
  '全屏伤敌 + 剧烈震屏 + 清弹':
    'Screen-wide damage, violent screen shake, and bullet clear.',
  '泪之护盾': 'Tear Shield',
  '清弹 + 10s 内挡下一次中弹':
    'Clears bullets and blocks one hit within 10s.',
  '混乱力场': 'Chaos Field',
  '清弹 + 敌机 5s 内射击错乱（射速减半）':
    'Clears bullets; enemy fire rate halved for 5s.',
  '应援结界': 'Cheer Barrier',
  '梦境领域': 'Dream Domain',
  '大范围清弹 + 敌机睡眠 3s（不射弹）':
    'Wide bullet clear; enemies sleep and stop firing for 3s.',
  '爱心爆发': 'Heart Burst',

  // ---------------- 角色：特殊 ----------------
  '无敌冲刺': 'Invincible Dash',
  '2.5s 无敌 + 移速提升 + 接触伤敌':
    '2.5s invincibility, faster movement, and contact damage.',
  '子弹时间': 'Bullet Time',
  '全场时间 0.35×，持续 2.5s':
    'Time slows to 0.35× for 2.5s.',
  '狂暴': 'Berserk',
  '大哭': 'Big Cry',
  '全力应援': 'Full Cheer',
  '魅惑': 'Charm',
  '屏上敌弹变点道具（上限 200）+ 3s 无敌':
    'Turns on-screen bullets into point items (max 200) + 3s invincibility.',

  // ---------------- 角色：技能浮字（characters.js 内 floatText） ----------------
  '无敌冲刺！': 'INVINCIBLE DASH!',
  '狂暴！！': 'BERSERK!!',
  '护盾展开': 'SHIELD UP',
  '加油！加油！': 'GO! GO!',

  // ---------------- 关卡名 ----------------
  '云端·天空': 'Sky of Clouds',
  '深海·水压': 'Deep-Sea Pressure',
  '齿轮·机械': 'Gearworks',
  '腐叶·森林': 'Rotting-Leaf Forest',
  '幽影·暗界': 'Shadow Realm',
  '星界·终焉': 'Starlit Terminus',
  '终焉回廊': 'Corridor of Demise',

  // ---------------- 关卡 say 台词 ----------------
  'STAGE 1  云端·天空': 'STAGE 1  Sky of Clouds',
  'STAGE 2  深海·水压': 'STAGE 2  Deep-Sea Pressure',
  'STAGE 3  齿轮·机械': 'STAGE 3  Gearworks',
  'STAGE 4  腐叶·森林': 'STAGE 4  Rotting-Leaf Forest',
  'STAGE 5  幽影·暗界': 'STAGE 5  Shadow Realm',
  'STAGE 6  星界·终焉': 'STAGE 6  Starlit Terminus',
  // 兜底测试关（gameScene makeFallbackStage）
  'STAGE 1 · 测试关': 'STAGE 1 · TEST',
  'STAGE 2 · 测试关': 'STAGE 2 · TEST',
  'STAGE 3 · 测试关': 'STAGE 3 · TEST',
  'STAGE 4 · 测试关': 'STAGE 4 · TEST',
  'STAGE 5 · 测试关': 'STAGE 5 · TEST',
  'STAGE 6 · 测试关': 'STAGE 6 · TEST',
  '测试关：正式关卡脚本就位后将替换本关': 'TEST STAGE: will be replaced once the real stage script lands',
  '警告：强大的气息接近了……': 'WARNING: a powerful presence approaches…',
  '第一形态': 'First Form',
  '狂暴形态': 'Raging Form',

  // ---------------- Boss 名 + 称号 ----------------
  '风暴精灵': 'Storm Sprite',
  '云端的中枢': 'Heart of the Clouds',
  '积雨云之王': 'King of Cumulonimbus',
  '天空的支配者': 'Ruler of the Skies',
  '深海灯笼鱼': 'Deep-Sea Anglerfish',
  '水压的引路者': 'Guide of the Depths',
  '深渊克拉肯': 'Abyssal Kraken',
  '深海的主宰': 'Master of the Deep',
  '哨戒机': 'Sentinel',
  '齿轮回廊的守卫': 'Guard of the Gear Corridor',
  '核心熔炉': 'Core Furnace',
  '机械城的心脏': 'Heart of the Machine City',
  '孢子菇后': 'Spore Mushroom Queen',
  '腐叶林的女王': 'Queen of the Rotting Woods',
  '千年树人': 'Millennium Treant',
  '森林的古老意志': 'Ancient Will of the Forest',
  '提灯鬼': 'Lantern Ghost',
  '暗界的引魂人': 'Soul Guide of the Dark Realm',
  '虚无之眼': 'Eye of the Void',
  '暗界尽头的凝视': 'Gaze at the End of Darkness',
  '彗星骑士': 'Comet Knight',
  '星界的先锋': 'Vanguard of the Star Realm',
  '星尘核心': 'Stardust Core',
  '终焉之核': 'Core of Demise',
  '星灵': 'Star Spirit',
  '终焉回廊的支配者': 'Master of the Corridor of Demise',

  // ---------------- 非符卡阶段名 ----------------
  '旋风': 'Whirlwind',
  '积雨压顶': 'Cumulus Crush',
  '雷电走线': 'Lightning Wiring',
  '诱光': 'Luring Light',
  '触手横扫': 'Tentacle Sweep',
  '墨云': 'Ink Cloud',
  '触手狂乱': 'Tentacle Frenzy',
  '警戒扫描': 'Alert Scan',
  '齿轮齐射': 'Gear Volley',
  '冲压墙': 'Press Wall',
  '蒸汽喷发': 'Steam Eruption',
  '孢子散播': 'Spore Spread',
  '菌丝缠绕': 'Mycelium Bind',
  '落叶': 'Falling Leaves',
  '花粉风暴': 'Pollen Storm',
  '千年之怒': 'Millennial Wrath',
  '鬼火引诱': 'Wisp Lure',
  '奇袭': 'Surprise Attack',
  '凝视': 'The Gaze',
  '加速突袭': 'Accelerating Rush',
  '瞳孔收缩': 'Pupil Constriction',
  '彗星冲锋': 'Comet Charge',
  '骑士连击': "Knight's Combo",
  '星尘散弹': 'Stardust Scatter',
  '弹幕变换': 'Pattern Shift',
  '终焉流星雨': 'Meteor Shower of Demise',
  '乱流': 'Turbulence',
  '暗流': 'Undercurrent',
  '链齿': 'Chain Sprocket',
  '风切': 'Wind Shear',
  '云海': 'Sea of Clouds',
  '暗涌': 'Dark Surge',
  '铆钉连射': 'Rivet Burst',
  '荆棘': 'Thorns',
  '暗雨': 'Dark Rain',
  '星尘壁垒': 'Stardust Rampart',

  // ---------------- 符卡名（X 符「Y」→ X Sign "Y"） ----------------
  '风符「旋涡气流」': 'Wind Sign "Vortex Gust"',
  '云符「积雨乱打」': 'Cloud Sign "Cumulus Barrage"',
  '岚符「天罚风暴」': 'Storm Sign "Heavenly Punishment"',
  '灯符「深海诱光」': 'Lamp Sign "Deep-Sea Lure"',
  '涡符「大漩涡」': 'Vortex Sign "Grand Maelstrom"',
  '泡符「深渊呼吸」': 'Bubble Sign "Abyssal Breath"',
  '锁符「回旋封锁」': 'Lock Sign "Spinning Blockade"',
  '链符「定时连锁」': 'Chain Sign "Timed Chain Reaction"',
  '炉符「超临界炉心」': 'Furnace Sign "Supercritical Core"',
  '孢符「风媒飞孢」': 'Spore Sign "Windborne Spores"',
  '藤符「封位蔓牢」': 'Vine Sign "Binding Bramble Prison"',
  '根符「大地脉动」': 'Root Sign "Pulse of the Earth"',
  '灯符「鬼火提灯」': 'Lantern Sign "Will-o\'-Wisp Lantern"',
  '暗符「无光之海」': 'Dark Sign "Lightless Sea"',
  '眼符「虚空凝视」': 'Eye Sign "Void Gaze"',
  '虚符「虚无降临」': 'Void Sign "Advent of Nothingness"',
  '彗符「星尘尾迹」': 'Comet Sign "Stardust Trail"',
  '星符「银河回旋」': 'Star Sign "Galactic Revolution"',
  '核符「超新星爆发」': 'Core Sign "Supernova Burst"',
  '星符「宇宙收缩」': 'Star Sign "Cosmic Contraction"',
  '壹符「星屑迎撃」': 'First Sign "Stardust Intercept"',
  '贰符「流星追尾」': 'Second Sign "Meteor Pursuit"',
  '叁符「十字激光阵」': 'Third Sign "Cross Laser Array"',
  '肆符「曲线回廊」': 'Fourth Sign "Curving Corridor"',
  '伍符「加速乱舞」': 'Fifth Sign "Accelerating Dance"',
  '陆符「菌毯蔓延」': 'Sixth Sign "Spreading Mycelium"',
  '柒符「蛇形矩阵」': 'Seventh Sign "Serpentine Matrix"',
  '捌符「终焉·全弹发射」': 'Eighth Sign "Demise: Full Barrage"',
  '飓符「台风眼壁」': 'Hurricane Sign "Typhoon Eyewall"',
  '渊符「深海沉光」': 'Abyss Sign "Sunken Light of the Deep"',
  '锯符「回旋锯阵」': 'Saw Sign "Whirling Saw Array"',
  '茸符「菌毯爆发」': 'Mushroom Sign "Mycelium Carpet Burst"',
  '影符「百鬼夜行」': 'Shadow Sign "Night Parade of a Hundred Demons"',
  '陨符「陨星碎击」': 'Meteor Sign "Meteor Shard Strike"',
  '雷符「轰雷阵」': 'Thunder Sign "Rolling Thunder Array"',
  '旋符「大旋风」': 'Whirl Sign "Great Cyclone"',
  '潮符「怒涛压境」': 'Tide Sign "Raging Billows Advance"',
  '漩符「螺旋海流」': 'Swirl Sign "Spiral Current"',
  '导符「制导导弹」': 'Guidance Sign "Homing Missiles"',
  '齿符「飞散齿轮」': 'Gear Sign "Scattering Gears"',
  '叶符「翠叶旋舞」': 'Leaf Sign "Dance of Verdant Leaves"',
  '精符「森之精魄」': 'Spirit Sign "Spirits of the Forest"',
  '灭符「永夜降临」': 'Ruin Sign "Eternal Night Descends"',
  '煌符「星火燎原」': 'Blaze Sign "Starfire Ignites the Plain"',
  '玖符「星链锁阵」': 'Ninth Sign "Star Chain Lockdown"',
  '拾符「终焉·星灵全开」': 'Tenth Sign "Demise: Star Spirit Unleashed"',

  // ---------------- 音乐室：曲目标题 / 副题 / 创作背景 ----------------
  '月下的开幕礼': 'Opening Rite Under the Moon',
  '标题画面主题曲': 'Title theme',
  ['标题画面的曲子。全长约 70 秒。C 利底亚调式 96 拍，主旋律交给了马林巴，' +
    '像八音盒一样一颗一颗地响，底下是弦乐长音和低音提琴拨弦。' +
    '从第二循环开始，一支长笛带着新的对位旋律加入进来——月亮升起来之后，总得有人陪它说话。' +
    '写的时候满脑子是「今晚也要出发了」的感觉。']:
    "The title theme, about 70 seconds long. C Lydian at 96 BPM, the lead given to a marimba, " +
    "ticking along one note at a time like a music box, over sustained strings and pizzicato double bass. " +
    "From the second loop on, a flute joins with a new counter-melody — " +
    "once the moon has risen, someone has to keep it company. " +
    "Writing it, all I had in mind was the feeling of \"off we go again tonight.\"",
  '云海散步道': 'Promenade Above the Clouds',
  '第一关·云端主题曲': 'Stage 1 · Cloud theme',
  ['第一关的曲子。全长约 84 秒，正好陪你跑完一趟云海。D 大调 148，主题交给单簧管，' +
    '八分泵音拨弦贝斯带着经过音往前跑。曲式是变奏式发展：主题、对比、小高潮、再回到主题，' +
    '织体一段一段加密，像云一层一层厚起来。小高潮（约 52 秒起）把主题整个抬高一个八度，' +
    '是穿出云层忽然亮开的一瞬。全程节奏一致、无缝循环；过关的收束句交给了专门的结尾曲。' +
    '毕竟是第一关，不设防地明亮到底。']:
    "Stage 1's theme, about 84 seconds — exactly one trip across the sea of clouds. " +
    "D major at 148 BPM, the theme given to a clarinet, eighth-note pumping pizzicato bass running ahead on passing tones. " +
    "The form develops like a set of variations: theme, contrast, small climax, and back to the theme, " +
    "the texture thickening section by section like clouds piling up. " +
    "The small climax (from about 0:52) lifts the whole theme an octave — " +
    "the moment you burst through the clouds into sudden brightness. " +
    "Steady rhythm throughout, seamless loop; the closing cadence for clearing the stage belongs to the dedicated ending track. " +
    "It's the first stage, after all — bright and defenseless to the end.",
  '深蓝摇篮': 'Deep-Blue Cradle',
  '第二关·深海主题曲': 'Stage 2 · Deep-sea theme',
  ['第二关·深海的曲子。全长约 90 秒。A 多利亚调式 96，通篇三连音，' +
    '摇摇晃晃像被水流推着走。主旋律是长笛——采样里自带的那点颤音，正好是水波的样子。' +
    '音域收窄了，深海里不需要大起大落。零星的钟琴声是从海面上漏下来的、很远的光。']:
    "Stage 2's deep-sea theme, about 90 seconds. A Dorian at 96 BPM, triplets all the way through — " +
    "swaying as if pushed along by the current. The lead is a flute; " +
    "the slight vibrato baked into the sample looks exactly like rippling water. " +
    "The range is narrowed — the deep sea has no need for dramatic rises and falls. " +
    "The sparse glockenspiel notes are distant light filtering down from the surface.",
  '齿轮心脏': 'Clockwork Heart',
  '第三关·机械主题曲': 'Stage 3 · Machine theme',
  ['第三关·机械的曲子。全长约 87 秒。E 小调 165，核心是一条短促的切分 ostinato riff，' +
    '两三个音像齿轮一样反复咬合，小号踩着切分节奏往前冲，底鼓四踩、拨弦贝斯十六分。' +
    '高潮段 riff 整体抬高八度，流水线换挡提速。请小心不要被卷进去。']:
    "Stage 3's machine theme, about 87 seconds. E minor at 165 BPM, built around a short, syncopated ostinato riff — " +
    "two or three notes meshing again and again like gears, while a trumpet charges ahead on the offbeats, " +
    "over a four-on-the-floor kick and sixteenth-note pizzicato bass. " +
    "In the climax the riff jumps an octave, like the assembly line shifting into a higher gear. " +
    "Careful not to get caught in it.",
  '光苔之森': 'Forest of Glowing Moss',
  '第四关·森林主题曲': 'Stage 4 · Forest theme',
  ['第四关·森林的曲子。全长约 89 秒。G 利底亚调式 118，单簧管加附点节奏，' +
    '蹦蹦跳跳的，像光斑在苔上跳。贝斯是低音提琴拨弦的 walking，一路经过音，' +
    '和声用反拍断奏留出空隙给鸟叫（并没有真的录进去）。' +
    '森林里迷路才是正事，走太快会错过蘑菇。']:
    "Stage 4's forest theme, about 89 seconds. G Lydian at 118 BPM, a clarinet with dotted rhythms, " +
    "hopping along like spots of sunlight skipping across the moss. " +
    "The bass is a pizzicato double-bass walking line, passing tones all the way, " +
    "and the harmony uses offbeat stabs to leave gaps for birdsong (not actually recorded). " +
    "Getting lost is the proper way to enjoy a forest — walk too fast and you'll miss the mushrooms.",
  '幽影回廊': 'Corridor of Shadows',
  '第五关·幽影主题曲': 'Stage 5 · Shadow theme',
  ['第五关·幽影的曲子。全长约 87 秒。D 弗里几亚调式的降二级一压下来，走廊就黑了。' +
    '速度只有 88，音符之间留了很多空白——在这座回廊里，空白比声音更可怕。' +
    '长笛贴着墙根走路，底鼓放慢成心跳，钟琴每隔一段才敲一下。请当作是为你敲的。']:
    "Stage 5's shadow theme, about 87 seconds. The moment D Phrygian's flattened second presses down, the corridor goes dark. " +
    "Only 88 BPM, with long silences between the notes — in this corridor, the silence is scarier than the sound. " +
    "The flute hugs the base of the walls, the kick slows to a heartbeat, " +
    "and the glockenspiel tolls only every so often. Please pretend it tolls for you.",
  '星尘尽头': 'End of Stardust',
  '第六关·星界主题曲': 'Stage 6 · Star-realm theme',
  ['第六关·星界的曲子。全长约 88 秒，终点前最后一段路。F# 小调 152，' +
    '小号吹着长线条的旋律一句一句往上爬，底下是加宽到四个音的弦乐 pad 和 walking 拨弦贝斯，' +
    '鼓放慢成半步感。小高潮来了两次，第二次更亮。抬头看看，星星都在为你让路。']:
    "Stage 6's star-realm theme, about 88 seconds — the last stretch before the finish. " +
    "F# minor at 152 BPM, a trumpet singing long-lined phrases that climb one by one, " +
    "over a string pad widened to four notes and a walking pizzicato bass, the drums eased into a half-time feel. " +
    "The small climax comes twice, the second time brighter. Look up: the stars are making way for you.",
  '风暴王的仪仗': 'Honor Guard of the Storm King',
  '云端 boss 主题曲': 'Cloud boss theme',
  ['云端 boss 的曲子。全长约 126 秒，展开→高潮→变奏再现，高潮埋在 36 秒左右。' +
    '沿用第一关的 D 大调但提到 160，主角从单簧管换成小号——' +
    '同一座云宫，道中听的是散步曲，王座前吹的是 fanfare。别被排场吓到，弹幕可比这个凶多了。']:
    "The cloud boss's theme, about 126 seconds — development, climax, varied reprise, the climax buried around 0:36. " +
    "Same D major as stage 1, but pushed to 160 BPM, and the lead swaps from clarinet to trumpet: " +
    "same cloud palace, but where the stage played a stroll, the throne room plays a fanfare. " +
    "Don't let the pageantry scare you — the danmaku is far fiercer.",
  '深渊的腕足': 'Arms of the Abyss',
  '深海 boss 主题曲': 'Deep-sea boss theme',
  ['深海 boss 的曲子。全长约 130 秒。三连音还在，但从摇篮变成了缠绕——克拉肯的腕足就是这种感觉吧。' +
    '主旋律交给了长号，从深水底部往上压，鼓换成沉重的三拍连打，高潮在 38 秒附近浮出海面。' +
    '这次的钟声听起来像沉船的钟。游泳圈请自备。']:
    "The deep-sea boss's theme, about 130 seconds. The triplets remain, but the cradle has become an embrace — " +
    "that's the kraken's arms for you. The lead goes to a trombone, pressing upward from the bottom of the deep, " +
    "the drums switched to heavy triple hits, and the climax breaks the surface around 0:38. " +
    "This time the bells sound like a sunken ship's bell. Bring your own swim ring.",
  '熔炉核心过载': 'Furnace Core Overload',
  '机械 boss 主题曲': 'Machine boss theme',
  ['机械 boss 的曲子。全长约 126 秒，175 仍是全曲库最快。' +
    '切分底鼓加拨弦贝斯的低音脉冲一路碾压，小号是短促的四音呼喊，喊完就走，绝不多留。' +
    '反拍断奏和双跳军鼓在后面追打，高潮约 38 秒处全线报警。建议在它冷却之前解决战斗。']:
    "The machine boss's theme, about 126 seconds — still the fastest in the library at 175 BPM. " +
    "A syncopated kick and pizzicato-bass low-end pulse grind forward, " +
    "while the trumpet is a terse four-note shout — said and done, never lingering. " +
    "Offbeat stabs and double-stroke snare chase from behind, " +
    "and at the climax around 0:38 every gauge screams at once. Best finish the fight before it cools down.",
  '千年树人的怒号': 'Roar of the Millennium Treant',
  '森林 boss 主题曲': 'Forest boss theme',
  ['森林 boss 的曲子。全长约 128 秒。利底亚的明亮还在，但 142 的速度加反拍断奏，' +
    '硬是把「散步」变成了「被树根追杀」。单簧管踩着附点节奏，那是树人跺脚的脚步声，' +
    '钟琴像年轮一样一圈圈荡开。活了千年的东西发火，场面大概就是这样。']:
    "The forest boss's theme, about 128 seconds. The Lydian brightness remains, but at 142 BPM with offbeat stabs, " +
    "the 'stroll' has become 'chased by tree roots.' The clarinet steps on dotted rhythms — that's the treant stomping — " +
    "and the glockenspiel ripples outward like tree rings. " +
    "This is what it looks like when something a thousand years old gets angry.",
  '虚无之眼的凝视': 'Gaze of the Void Eye',
  '幽影 boss 主题曲': 'Shadow boss theme',
  ['幽影 boss 的曲子。全长约 122 秒。D 弗里几亚继续压暗，速度从关卡的 88 提到 118——' +
    '那只眼睛盯过来的时候，心跳确实会快这么多。长笛的旋律稀疏得只剩注视，' +
    '底鼓和军鼓放得很沉，钟琴一下一下，像敲在太阳穴上。别盯着它看太久。']:
    "The shadow boss's theme, about 122 seconds. D Phrygian keeps pressing darker, " +
    "and the tempo rises from the stage's 88 to 118 BPM — " +
    "which is exactly how much your heart races when that eye turns on you. " +
    "The flute melody thins out until only the gaze remains, the kick and snare sit heavy, " +
    "and the glockenspiel strikes again and again, like blows to the temple. Don't stare back too long.",
  '星尘核心崩解': 'Stardust Core Collapse',
  '星界 boss 主题曲': 'Star-realm boss theme',
  ['最终 boss 的曲子。全长约 131 秒。多主题轮换：A 段全员齐奏断音，像核心外壳一层层碎裂；' +
    'B 段换成高八度的流动旋律加宽幅弦乐 pad，八分对位像星图一样铺开。' +
    '168 的速度、双主题的排场，高潮约 40 秒处核心开始崩解。打到这里的人，请把这首当作饯别礼。']:
    "The final boss's theme, about 131 seconds. Multiple themes in rotation: " +
    "the A section's full-ensemble staccato cracks like the core's shell splitting layer by layer; " +
    "the B section shifts to a flowing high-octave melody over a wide string pad, " +
    "its eighth-note counter-lines spreading like a star chart. " +
    "168 BPM and a two-theme production, and at the climax around 0:40 the core begins to collapse. " +
    "If you've made it this far, take this track as my parting gift.",
  '回廊巡礼': 'Pilgrimage of the Corridor',
  ['额外关「终焉回廊」道中的曲子。全长约 82 秒，正好陪你走到王座门前。' +
    '与 boss 曲「决战时刻」同用 B 弗里几亚调式——同一座回廊，道中是走向王座的脚步，王座前才是决战。' +
    '速度压到 140（boss 曲 172），主旋律交给长笛蜿蜒而行，羽管键琴的十六分音像回廊深处不知疲倦的齿轮，' +
    '远处的钟声一下一下，数着你还剩多少路。高潮埋在 41 秒左右，然后留一点空白——门就要开了。']:
    "The stage theme of EXTRA STAGE \"Corridor of Demise,\" about 82 seconds — " +
    "just long enough to walk you to the throne room door. " +
    "It shares B Phrygian with the boss theme \"Moment of Decisive Battle\": same corridor, " +
    "but the stage theme is the footsteps walking toward the throne; the battle comes after. " +
    "Tempo held down to 140 (the boss track runs 172), the lead given to a winding flute, " +
    "harpsichord sixteenths ticking like tireless gears deep in the corridor, " +
    "and distant bells tolling off how much road remains. " +
    "The climax is buried around 0:41, then a little silence — the door is about to open.",
  '决战时刻': 'Moment of Decisive Battle',
  ['额外关「终焉回廊」的主题曲，全长约 128 秒，写给单关 10 符卡连战的长夜。' +
    'B 弗里几亚调式 172，小号加八分琶音，紧张感像公式一样叠满，展开→高潮→再现一座三连。' +
    '曾经是通用 boss 兜底曲，如今转正为 Extra 专用——没有续关的回廊里，它就是唯一的仪仗。']:
    "The theme of EXTRA STAGE \"Corridor of Demise,\" about 128 seconds, " +
    "written for the long night of a single-stage, ten-spell-card gauntlet. " +
    "B Phrygian at 172 BPM, trumpet plus eighth-note arpeggios stacking tension like a formula — " +
    "development, climax, and reprise, three in a row. " +
    "Once the generic boss fallback track, it's now officially promoted to Extra-only duty — " +
    "in a corridor with no continues, it's the only honor guard you get.",
  '云上凯旋式': 'Triumphal Parade Above the Clouds',
  '过关结算结尾曲': 'Stage-clear ending theme',
  ['过关结算时播放的结尾曲，全长约 10 秒，不循环，播完即止。D 大调 200，' +
    '小号吹一句上行的 fanfare（I-IV-V-I 一路往上推），长音收束时弦乐对位和钟琴星点一起落下来。' +
    'loop 曲目全程不再放慢——收束这件事，交给这首专门的曲子来做。']:
    "The ending fanfare played on the stage-clear tally screen, about 10 seconds — no loop, played once and done. " +
    "D major at 200 BPM, a trumpet blowing an ascending fanfare (driving up I-IV-V-I), " +
    "and as the final note holds, the string counter-line and glockenspiel sparkles rain down together. " +
    "The looped tracks never slow down for an ending anymore — that job belongs to this dedicated piece.",
  '谢幕后的星空': 'The Sky After the Curtain Call',
  '制作名单主题曲': 'Credits theme',
  ['制作名单场景的曲子，全长约 70 秒，为滚动的名字们而作。C 大调 96，' +
    '长笛吹着长线条的旋律，弦乐 pad 铺底，鼓只留一点心跳似的脉冲，钟琴远远地敲。' +
    '曲式走主题、对比、再回主题，结尾四句自然放慢收束——这首不作紧张 loop 用，慢一点没关系。' +
    '仗打完了，该坐下来看看星星，顺便看看都是谁陪你打了这一仗。']:
    "The credits theme, about 70 seconds, written for the rolling names. C major at 96 BPM, " +
    "a flute singing long-lined phrases over a string pad, the drums reduced to a heartbeat-like pulse, " +
    "and the glockenspiel tolling far away. The form runs theme, contrast, and back to theme, " +
    "and the final four bars slow into a natural close — this one is no tense loop, so it can afford to. " +
    "The battle is over; time to sit back, watch the stars, and see exactly who fought it beside you.",

  "我绕着自己打转，风就跟着我打转——一会儿左旋，一会儿右旋。看傻了可不行，涡流会把你一起卷进去的哦。": "I spin around, and the wind spins with me — left for a while, then right. Don't stare too long, or the vortex will sweep you in too.",
  "台风里最安全的地方是风眼。我把风墙转着压过去，只给你留一个口——敢不敢钻进来，和我面对面？": "The safest place in a typhoon is the eye. My wall spins as it closes in, leaving you exactly one gap — dare to dive in and face me?",
  "云越积越厚，雨越下越急。我的积雨云从来不一次下完，它喜欢先试探，再倾盆。": "Clouds pile up, rain falls harder. My storm never pours all at once — it tests you first, then opens the floodgates.",
  "旋臂、花瓣、暴雨一齐上场的时候，连我自己都要让三分。这是天空的全力，你姑且当作天罚来躲吧。": "Spirals, petals, and downpour all at once — even I have to step aside. This is the sky's full power; dodge it like divine punishment.",
  "雷不劈同一个地方？那是凡人的雷。我的落雷专挑你站的地方劈，半路还会拐弯。": "Lightning never strikes twice? That's mortal lightning. Mine strikes exactly where you stand — and it turns corners.",
  "暴风雨的终曲是一支圆舞。风往哪边转，雨就往哪边倒——跟上节拍，或者被我卷走。": "The storm's finale is a round dance. Wherever the wind turns, the rain follows — keep the beat, or be swept away.",
  "深海里没有光，除了我这一盏。灯火明明灭灭地飘过来，跟着光走的孩子，最后都到我嘴里来了。": "There is no light in the deep sea, except mine. It drifts toward you, flickering — every child who follows it ends up in my mouth.",
  "沉下去的光是什么样子？大颗大颗，慢慢地开，像花在墨里绽。卷流会替我推你一把，别客气。": "What does sunken light look like? Big, slow blooms, like flowers opening in ink. The current will give you a push — you're welcome.",
  "我的腕足搅一搅，海就转起来了。卷向说变就变——海流听我的，不听你的。": "One stir of my arms and the sea starts turning. The spin reverses on a whim — the current obeys me, not you.",
  "深渊也会呼吸。一呼一吸，花都跟着涨落。你屏住呼吸没用，它又不听你的。": "The abyss breathes too. In, out — and the flowers swell and fade with it. Holding your breath won't help; it doesn't obey you either.",
  "浪一排一排压过来，缺口换来换去。被追上的话，就当我给你一个拥抱吧——用八条腕足。": "Waves press in, rank after rank, the gap shifting each time. If one catches you, consider it a hug — with all eight arms.",
  "见过大漩涡长出骨架的样子吗？旋臂是骨，卷流是肉。这张网撒出去，连我自己都收不回来。": "Ever seen a whirlpool grow a skeleton? Spiral arms for bones, currents for flesh. Once I cast this net, even I can't take it back.",
  "警告：本机封锁光束每五秒换向一次。规避窗口已计算完毕——不会告诉你的，自己算。": "Warning: lockdown beam reverses every five seconds. Evasion window computed — and no, I won't tell you. Do your own math.",
  "锯片臂数：三、四、五。转速：呼吸变速。警告：本机不对被切割者的体验负责。": "Saw arms: three, four, five. Rotation: breathing variable speed. Warning: this unit is not responsible for the sliced user's experience.",
  "听，咔、咔——停。齿轮咬两扣，歇一口气。这就是我心跳的声音，你跟得上吗？": "Listen: click, click — rest. The gears bite twice, then breathe. That is my heartbeat. Can you keep up?",
  "温度上来了！旋臂越转越快，脉冲一圈比一圈密。炉心过载之前，要么你先退，要么我炸给你看。": "Temperature rising! The arms spin faster, the pulses pack tighter. Before the core overloads — either you back off, or I blow.",
  "导弹一旦锁定，只会越咬越死，甩是甩不掉的。唯一的办法是别站着不动——虽然是废话。": "Once locked on, the missiles only bite deeper. You can't shake them. Just keep moving — obvious, I know.",
  "大齿轮小齿轮一起甩出去，离心力把它们掰成弯的。流水线嘛，偶尔也出点飞件。": "Big gears, small gears, flung out together, bent by centrifugal force. Even an assembly line throws off a few parts.",
  "我的孩子们乘风去旅行，落在哪儿，就在哪儿住下。你也当心，别让它们落在你身上。": "My children ride the wind and settle wherever they land. Do be careful — don't let them land on you.",
  "菌毯醒来的时候，花一丛一丛地开，孢子像雨一样落。踩过我的地毯，总要付出点代价。": "When the mycelium wakes, flowers burst open in patches and spores fall like rain. Walk across my carpet, and there's a price.",
  "藤蔓不急。它先围起来，再把缺口一个个挪开。一千年了，没有谁跑得过耐心。": "Vines are patient. They close around you first, then shift the gaps one by one. A thousand years, and nothing has outrun patience.",
  "把手放在地上，你摸到的就是它的脉。一胀，一缩。我的根，比你想象的走得远。": "Put your hand on the ground — that pulse is mine. Swell, shrink. My roots reach farther than you think.",
  "落叶也会跳舞，转够了就换个方向。年轻人，别光看叶子好看——舞池里是不能停脚的。": "Fallen leaves dance too, and switch direction when the turn is done. Don't just admire them, child — a dance floor is no place to stand still.",
  "林子里的小东西喜欢你，会一直跟着你。花开了又谢，谢了又开——它们可不懂什么叫客气。": "The little ones of the forest like you; they will follow you forever. Flowers bloom and fade, bloom and fade — they never learned manners.",
  "提灯一晃，鬼火就飘过去了。忽明忽暗，才是引路的样子嘛。跟紧哦——跟丢了可不怪我。": "One swing of my lantern, and the ghost flames drift over. Flickering is what a guide should look like. Keep up — or don't blame me.",
  "夜行的队伍出发咯。小鬼火三三两两地走，走得慢的可别掉队。哎呀，你也在队伍里吗？": "The night parade sets off. Little flames walk in twos and threes — stragglers beware. Oh my, are you in the parade too?",
  "海没有光，一波一波地涨。你在里面能看见什么？什么都看不见，除了我在看你。": "A sea without light, swelling wave after wave. What can you see in it? Nothing — except me, watching you.",
  "被盯着的东西会越转越快。我的视线不拐弯，我的弹幕会。眨眼，就算你输。": "Whatever I stare at spins faster and faster. My gaze doesn't turn corners — my bullets do. Blink, and you lose.",
  "紫色，蓝色，紫色，蓝色。虚无没有颜色，所以什么颜色都可以是。沉进去吧。": "Purple, blue, purple, blue. The void has no color, so any color will do. Sink in.",
  "夜落下来的时候，连弹幕都会被压弯。换个方向，再压一次。永夜的意思就是：不会天亮。": "When night falls, even bullets bend under it. Then it bends them the other way. Evernight means: no dawn.",
  "彗星过境，尾迹会留下来陪你玩。小心，它们还会在半空碎成星尘——优雅，但是危险。": "When a comet passes, its trail stays behind to play with you. Careful — it shatters into stardust midair. Elegant, but dangerous.",
  "正面接下我的陨星雨吧！砸下来还不算完，碎了还要再追你一段。骑士的问候，从来不只一下。": "Take my meteor rain head-on! The impact isn't the end — the shards chase you further. A knight's greeting is never just once.",
  "银河就这样转了一百亿年，快一阵，慢一阵。你倒是第一个想从旋臂里穿过去的。": "The galaxy has turned like this for ten billion years, faster, then slower. You're the first to try slipping through its arms.",
  "恒星燃尽的时候会换一种颜色，再换一种颜色。看好了——这是我最亮的样子。": "A dying star changes color, then changes again. Watch closely — this is me at my brightest.",
  "宇宙到最后会往回收。反着转，缩着走，所有花样一起来。能见证这一幕，你运气不错。": "In the end, the universe pulls back inward. Reverse spin, shrinking rings, every trick at once. Lucky you, to witness it.",
  "一点星火，被热浪卷成环，碎开来就是一片原。燃烧这种事，我最懂了。": "One spark, curled into rings by the heat, scatters into a wildfire. Burning — that's what I know best.",
  "回廊的规矩第一条：先接住星屑。旋臂转着，礼花开着——欢迎来到终焉回廊。": "First rule of the corridor: catch the stardust. Spirals turning, fireworks blooming — welcome to the Corridor of Demise.",
  "流星一旦认出你，就会一直追。追上之前，还会在半空开花。被星星喜欢，是要付出代价的。": "Once a meteor knows you, it chases you forever. And it blossoms midair before it catches up. Being loved by stars has a price.",
  "十字封场，来回地扫。回廊里没有死角，只有还没扫到的地方。": "A cross of lasers, sweeping back and forth. There are no blind spots in this corridor — only places not yet swept.",
  "直来直去的回廊多没意思。我把它卷起来——墙还是那堵墙，路可不是那条路了。": "A straight corridor is so dull. I curl it up — same walls, but a very different road.",
  "舞会开始了。灯球转着，舞步越跳越快。踩错一拍？那就当给我助兴了。": "The ball begins. The disco ball spins, the steps get faster. Miss a beat? Consider it my entertainment.",
  "借来的地毯，意外地好用。孢子在回廊里扎了根，一圈一圈地等你。——谢啦，菇后。": "A borrowed carpet, and it works surprisingly well. The spores took root in the corridor, waiting for you ring after ring. — Thanks, Mushroom Queen.",
  "蛇会走直线吗？矩阵会扭吗？在我这里都会。扭的幅度嘛，看我心情。": "Can a snake go straight? Can a matrix wiggle? Here, both do. How much they wiggle depends on my mood.",
  "终焉第一幕：全弹发射。青的紫的一起来，转够八秒换一边。撑住，这才刚开始。": "Finale, act one: full barrage. Cyan and purple together, reversing every eight seconds. Hold on — this is just the beginning.",
  "星链一扣一扣地锁，墙一排一排地围。咔、咔——停。你猜，下一扣锁在哪里？": "Star chains lock link by link, walls close rank by rank. Click, click — pause. Guess where the next link lands?",
  "最后一幕，星灵全开。花按彩虹的顺序开，蛇形按着呼吸扭。过了这关，回廊就没有秘密了。": "Final act: the Star Spirit unleashed. Flowers bloom in rainbow order, snakes wiggle to a breath. Clear this, and the corridor has no secrets left.",

  "何人在寡人的云海踏浪？风都替你紧张起来了。": "Who treads the waves of my cloud sea? Even the wind is nervous for you.",
  "我叫开开心！借你的云打个招呼——弹幕，来啦！": "I'm KaiKai! Borrowing your clouds to say hi — danmaku, coming up!",
  "过路。让开。": "Passing through. Move.",
  "挡路的？正好，我手痒了！": "In my way? Perfect — my trigger finger was itching!",
  "那、那个……我只是路过……呜……": "U-um... I'm just passing through... *sniff*...",
  "咦？云……成精了？": "Huh? The clouds... came alive?",
  "路过顺便给你加个油——然后打一架！": "Passing by, here to cheer you on — and then fight you!",
  "唔……好软的云……能睡个午觉吗……": "Mmm... such soft clouds... can I nap here...?",
  "萌萌路过~大个子你会比心吗？": "Moe passing through~ Hey big guy, can you do a heart sign?",
  "只是路过的弹幕使。借过。": "Just a passing danmaku user. Excuse me.",
  "借过？云海没有路，只有风向。逆着寡人的风，半步也休想。": "Excuse you? The cloud sea has no roads, only wind. Against my wind, not half a step.",
  "那我就顺着你的风跳个舞给你看！": "Then I'll ride your wind and show you a dance!",
  "风会停。你不会赢。": "Wind stops. You won't win.",
  "我把你的风全打回去！": "I'll blow your wind right back at you!",
  "对不起对不起……但、但是我不能退……！": "S-sorry, sorry... b-but I can't back down...!",
  "风……往哪边吹来着？": "Which way... does the wind blow again?",
  "风向什么的，看我的气势把它吹回去！": "Wind direction? Watch me blow it back with spirit!",
  "逆风……好困……快点打完吧……": "Headwind... so sleepy... let's finish this quick...",
  "风再大，也吹不走我的可爱~": "No wind can blow away my cuteness~",
  "那我只好自己开一条路了。": "Then I'll carve a road of my own.",
  "好胆色。那就让积雨云看看——你能接住几滴天罚。": "Bold. Then show the storm clouds — how many drops of heaven's punishment you can catch.",
  "水面上的客人……是灯的甜味引你下来的吗？": "A guest from above the waves... did the sweetness of my light lure you down?",
  "是你的派对灯光太好看啦！带我一个！": "Your party lights are gorgeous! Count me in!",
  "你的灯，太晃眼。": "Your light. Too glaring.",
  "少废话！上来就打！": "Cut the talk! Fight me!",
  "呜……这里好黑……你的灯可以借我一下吗……": "*Sniff*... it's so dark here... could I borrow your light...?",
  "咦，是你约我下来的吗？": "Huh, did you invite me down here?",
  "深海巡游第一站！克拉肯，接招！": "First stop of my deep-sea tour! Kraken, take this!",
  "水里好舒服……想边睡边打……": "The water's so comfy... fight while napping...",
  "哇，八条腿！可以帮我扎头发吗？": "Wow, eight arms! Can you braid my hair?",
  "我只是追着弹幕的轨迹下来的。": "I just followed the danmaku trail down.",
  "深海没有甜，只有压。你的骨头会先替我尝到。": "No sweetness in the deep, only pressure. Your bones will taste it first for me.",
  "压强什么的，笑着就顶住啦！": "Pressure? I'll hold it with a smile!",
  "我的枪比你的压更重。": "My guns weigh more than your pressure.",
  "看我把你煮成章鱼烧！": "I'll cook you into takoyaki!",
  "骨、骨头会断掉吗……好可怕……但我不走！": "W-will my bones break...? Scary... but I'm not leaving!",
  "压？是哪一种压？": "Pressure? Which kind?",
  "我的热血，深海也煮得沸！": "My hot blood boils even the deep sea!",
  "压一压……更好睡……": "A little pressure... helps me sleep...",
  "压力讨厌~萌萌要浮起来！": "Pressure is mean~ Moe wants to float!",
  "那就比比谁先被压垮。": "Let's see who gets crushed first.",
  "有趣。腕足已张开——这场拥抱，你躲不掉。": "Amusing. My arms are open — you can't dodge this hug.",
  "警告：核心区域，非授权单位。立即停机，接受熔解。": "Warning: core sector, unauthorized unit. Shut down and accept meltdown.",
  "拒绝停机！我还要去玩呢！": "Shutdown denied! I still want to go play!",
  "授权？我就是。": "Authorization? That's me.",
  "熔解？！我先把你拆了卖废铁！": "Meltdown?! I'll scrap you for parts first!",
  "对、对不起，我这就走……咦，走不掉？": "S-sorry, I'll leave right away... huh, I can't?",
  "停机……是按哪个钮？": "Shut down... which button is that?",
  "检测报告：你这炉子火力不足！": "Inspection report: this furnace is underpowered!",
  "停机……好耶……那我可以睡了吗……": "Shut down... yay... can I sleep now...?",
  "熔解好可怕~萌萌会化掉的！": "Meltdown is scary~ Moe will melt!",
  "我只是借道的，不打算停机。": "I'm just passing through. No plans to shut down.",
  "借道申请驳回。本炉每分钟熔解借道单位十二个。": "Passage request denied. This furnace melts twelve passers-by per minute.",
  "那我做第十三个——特别难熔的那种！": "Then I'll be number thirteen — the extra-hard-to-melt kind!",
  "你的产量，今天归零。": "Your output drops to zero today.",
  "才十二个？我一个顶一百个！": "Only twelve? I'm worth a hundred!",
  "呜……我不想被熔解……我要回家……": "*Sniff*... I don't want to melt... I want to go home...",
  "十二个……那第十三个免费吗？": "Twelve... is the thirteenth free?",
  "熔解之前，先尝尝我的热血！": "Before you melt me, taste my hot blood!",
  "十二个……数着数着就困了……": "Twelve... counting them makes me sleepy...",
  "驳回无效~萌萌的票是永久的！": "Denial rejected~ Moe's ticket is permanent!",
  "那今天这个数字到你为止。": "Then that number stops at you today.",
  "炉心升温。链齿咬合——开始熔解程序。": "Core heating. Gears engaged — meltdown protocol initiated.",
  "慢些。再慢些。你听，腐叶下面，都是千年的根。": "Slower. Slower still. Listen — beneath the rotten leaves, roots a thousand years old.",
  "树爷爷好！你的叶子我能捡一片吗？": "Hi grandpa tree! Can I pick one of your leaves?",
  "让路，老树。": "Move aside, old tree.",
  "千年？烧掉只要十分钟！": "A thousand years? Ten minutes to burn!",
  "对、对不起……我踩疼你的根了吗……": "S-sorry... did I hurt your roots...?",
  "根……在跟我说话？": "The roots... are talking to me?",
  "千年古树！值得我全力一战！": "A thousand-year tree! Worth my full power!",
  "千年……那你一定很困吧……": "A thousand years... you must be so sleepy...",
  "树爷爷，萌萌可以在这里野餐吗？": "Grandpa tree, can Moe have a picnic here?",
  "久仰。我只是路过的客人。": "Honored. Just a passing guest.",
  "客人踩断了三根细根。千年了，我学会的第一课，就是不再原谅。": "The guest broke three fine roots. In a thousand years, the first thing I learned was to stop forgiving.",
  "那我赔你一场热闹！森林最喜欢热闹了！": "Then I'll pay you back with a party! Forests love parties!",
  "我数着的。两根。": "I counted. Two.",
  "才三根？我让你断三千根！": "Only three? I'll break three thousand!",
  "呜哇——对不起！我、我给你浇水！": "Waaah—sorry! I-I'll water you!",
  "三根……是左边那三根吗？": "Three... the three on the left?",
  "那我用全力道歉——全力一战！": "Then I apologize with full power — an all-out fight!",
  "原谅我嘛……我只是想睡觉……": "Forgive me... I just wanted to nap...",
  "萌萌这么轻，怎么会断呢~？": "Moe is so light, how could they break~?",
  "那我只好用胜利道歉了。": "Then I'll apologize with a victory.",
  "藤蔓不急。它有一整个下午，把你留在这里。": "The vines are patient. They have all afternoon to keep you here.",
  "你看得见我吗？这里很暗。暗到只剩我在看你。": "Can you see me? It's dark here. So dark only my watching remains.",
  "看得见呀！这么大一只眼睛，想看不见都难！": "Of course! An eye that big is hard to miss!",
  "看够了就闭眼。": "Seen enough? Close it.",
  "看什么看！把你打成瞎子！": "What are you staring at! I'll beat you blind!",
  "呜……被盯着看……好可怕……": "*Sniff*... being watched... so scary...",
  "咦，是谁在说话？": "Huh, who's talking?",
  "那就看看我的光！亮瞎你！": "Then watch my light! It'll blind you!",
  "黑黑的……正好睡觉……": "So dark... perfect for sleeping...",
  "萌萌这么可爱，看个够吧~": "Moe is this cute, stare all you want~",
  "彼此彼此。": "Likewise.",
  "每个进来的人都这么说。他们最后都把眼睛留在了这里。": "Everyone who enters says that. They all left their eyes here in the end.",
  "眼睛才不给你！我还要用它看明天的太阳！": "You're not getting my eyes! I need them for tomorrow's sun!",
  "试试。": "Try me.",
  "我把你的眼睛挖出来陪葬！": "I'll dig your eye out for my grave goods!",
  "不、不要！我的眼睛还要留着哭……": "N-no! I still need my eyes to cry...",
  "留眼睛……怎么留？": "Leave eyes... how?",
  "我的视线是燃着的——拿不住！": "My gaze is on fire — you can't hold it!",
  "眼睛给你……眼皮给我留下……": "Take the eyes... leave me the eyelids...",
  "不给~萌萌要眼睛来卖萌的！": "No way~ Moe needs those eyes to be cute!",
  "你留不住我的。": "You can't keep mine.",
  "那现在，换我仔细看看你——别眨眼。": "Now it's my turn to look at you — don't blink.",
  "旅人，你走到了星屑的尽头。再往前，就是终焉。": "Traveler, you've reached the end of stardust. Beyond lies the Demise.",
  "终焉？听起来像最后一关！那我更要冲了！": "Demise? Sounds like the final stage! All the more reason to charge!",
  "终焉见多了。让开。": "Seen plenty of demises. Move.",
  "终焉？！我先把你终焉了！": "Demise?! I'll demise YOU first!",
  "终、终焉……听起来好可怕……但我不能回头……": "D-demise... sounds terrifying... but I can't turn back...",
  "咦？这里就是最后一关吗？": "Huh? This is the last stage?",
  "燃烧到星屑的尽头——正合我意！": "Burning to the end of stardust — just my style!",
  "终焉……打完就能睡了吧……": "Demise... I can sleep after this, right...?",
  "终焉是什么？能吃吗？": "What's a demise? Can I eat it?",
  "那就把终焉变成我的终点线。": "Then I'll make your demise my finish line.",
  "星尘核心的每一次脉动，都是一个世界的余烬。你要以肉身贴近它？": "Every pulse of the Stardust Core is a world's ember. You'd approach it in mortal flesh?",
  "余烬也是光呀！我来替你点亮下一把火！": "Embers are light too! I'll kindle the next fire for you!",
  "我贴近过的核心，不止你一个。": "You're not the first core I've approached.",
  "脉动？打爆了就不脉了！": "Pulse? It stops when I blow you up!",
  "余、余烬会烫吗……呜……但我不会退！": "A-are embers hot...? *sniff*... but I won't retreat!",
  "贴近？多远算贴近？": "Approach? How close counts?",
  "我的血也是余烬燃的！比比谁烫！": "My blood burns with embers too! Let's compare heat!",
  "余烬……暖烘烘的……适合睡觉……": "Embers... so warm... perfect for sleeping...",
  "余烬也要萌萌地烧！": "Embers should burn cutely too!",
  "贴近了，才能打穿它。": "Only by getting close can I pierce it.",
  "那么——银河回旋，为你让路。前提是，你过得去。": "Then — the galaxy spins aside for you. If you can pass.",
  "回廊的考官见过许多来客。走到王座前的，你是第一个。": "The corridor's examiner has seen many guests. You are the first to reach the throne.",
  "第一个？那我要拿满分！": "The first? Then I'm getting full marks!",
  "考官？我只带枪来。": "Examiner? I only brought guns.",
  "少摆架子！你的题我全拆了！": "Drop the act! I'll smash all your questions!",
  "考、考试？我没复习……呜……": "A-an exam? I didn't study... *sniff*...",
  "咦？要考试吗？考什么？": "Huh? An exam? On what?",
  "毕业考是吧！看我的热血答卷！": "Graduation exam?! Watch my burning answers!",
  "考完……就能睡了吧……": "After the exam... I can sleep, right...?",
  "考官老师~可以开卷吗？": "Teacher~ is it open-book?",
  "第一个，但不会是最后一个。": "The first, but not the last.",
  "十道符卡，没有续关。答错一题，就留在回廊里当星屑。": "Ten spell cards, no continues. One wrong answer, and you stay as stardust.",
  "十道全对！星屑还是留给你自己吧！": "All ten correct! Keep the stardust for yourself!",
  "出题吧。": "Ask away.",
  "一题都不会错！错了我把回廊烧了！": "Not one wrong! Wrong, and I burn the corridor down!",
  "不、不要当星屑……我要回家……": "I-I don't want to be stardust... I want to go home...",
  "星屑……和星星是亲戚吗？": "Stardust... is it related to stars?",
  "十道而已！我的热血够答一百道！": "Only ten! My blood could answer a hundred!",
  "十道……数着数着就困了……": "Ten... counting them makes me sleepy...",
  "萌萌的答案都是满分答案~": "Moe's answers are all full marks~",
  "那就一题一题打过去。": "Then I'll fight through them one by one.",
  "很好。终焉回廊，开考。": "Good. The Corridor of Demise — exam begins.",

  "环波 3 波 + 每波 10 向子机齐射": "3 ring waves + 10-way option volley per wave",
  "2 波心形追踪弹（每波 6 颗）锁定敌人": "2 waves of homing heart shots (6 each) that lock onto enemies",
  "思维混乱": "Mind Chaos",
  "4s 内屏上敌弹方向错乱（随机摆动）": "For 4s, enemy bullets lose their way (random wobble)",
  "全屏敌弹 50% 变成点道具（上限 300 颗）": "Turn 50% of enemy bullets into point items (max 300)",
  "0.8s 无敌并向前瞬移一段距离": "0.8s invincible and blink forward",
  "睡遁": "Sleep Blink",
  "6s 射速×1.6、伤害×1.3": "For 6s: fire rate ×1.6, damage ×1.3",
  "8s 子机火力×2 + 自机移速×1.15": "For 8s: options ×2 firepower, move speed ×1.15",
  "诶…？": "Huh...?",

  "2s 连环分区爆破：每爆清一区并伤敌（伪全屏）": "2s chain bursts: each blast clears one zone and damages it (pseudo-fullscreen)",

  "额外关·终焉回廊": "EXTRA STAGE: Corridor of Demise",
  "额外关  终焉回廊": "EXTRA STAGE  Corridor of Demise",
  "额外关 CLEAR!!": "EXTRA CLEAR!!",
  "额外关道中主题曲": "EXTRA STAGE stage theme",
  "额外关 boss 主题曲": "EXTRA STAGE boss theme",

};
